import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Upload, message, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

export default function ImageUpload({onChange}){

    const [file, setFile] = useState(null);

    const onFileChange = event => {
        setFile(event.target.files[0]);
        onChange(event.target.files[0]);

    };

    return (
        <>
            <div style={{marginBottom: '20px'}}>
                <input type="file"  onChange={onFileChange} />
            </div>

        </>
    )
}

// import React, { useState, useCallback, useRef, useEffect } from 'react';
// import ReactCrop from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css';
// import { Modal, Button } from 'antd';
// import {useApi} from "../provider/ApiProvider";
// import {RightSquareOutlined, CheckCircleFilled} from "@ant-design/icons";
//
//
// export default function ImageUpload({name, value, onChange}){
//     const [dialog, setDialog] = useState(false);
//     const [data, setData] = useState(null);
//     const {api} = useApi();
//
//     const getResult = (result) =>{
//
//         onChange(result);
//     }
//
//     const save = () => {
//         // api.upload("/uploadRouter/image/save",formData).then(resp => {
//         //
//         // })
//     }
//
//     return (
//         <div style={{marginBottom: '10px'}}>
//             <Button onClick={() => setDialog(true)} icon={value ? <CheckCircleFilled style={{color: 'green'}} /> : ""}>Resim yükle</Button>
//             <ImageUploadModal open={dialog} getResult={getResult} onClose={() => setDialog(false)}/>
//         </div>
//     )
// }
//
// function ImageUploadModal({open, getResult, onClose}) {
//     const [upImg, setUpImg] = useState();
//     const imgRef = useRef(null);
//     const previewCanvasRef = useRef(null);
//     const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: 16 / 9 });
//     const [completedCrop, setCompletedCrop] = useState(null);
//
//     function generateDownload(canvas, crop) {
//         if (!crop || !canvas) {
//             return;
//         }
//
//
//         canvas.toBlob(
//             (blob) => {
//                 getResult(blob);
//                 onClose();
//             },
//             'image/png',
//             1
//         );
//     }
//
//     const onSelectFile = (e) => {
//         if (e.target.files && e.target.files.length > 0) {
//             const reader = new FileReader();
//             reader.addEventListener('load', () => setUpImg(reader.result));
//             reader.readAsDataURL(e.target.files[0]);
//         }
//     };
//
//     const onLoad = useCallback((img) => {
//         imgRef.current = img;
//     }, []);
//
//     useEffect(() => {
//         if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
//             return;
//         }
//
//         const image = imgRef.current;
//         const canvas = previewCanvasRef.current;
//         const crop = completedCrop;
//
//         const scaleX = image.naturalWidth / image.width;
//         const scaleY = image.naturalHeight / image.height;
//         const ctx = canvas.getContext('2d');
//         const pixelRatio = window.devicePixelRatio;
//
//         canvas.width = crop.width * pixelRatio;
//         canvas.height = crop.height * pixelRatio;
//
//         ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//         ctx.imageSmoothingQuality = 'high';
//
//         ctx.drawImage(
//             image,
//             crop.x * scaleX,
//             crop.y * scaleY,
//             crop.width * scaleX,
//             crop.height * scaleY,
//             0,
//             0,
//             crop.width,
//             crop.height
//         );
//     }, [completedCrop]);
//
//     return (
//         <Modal
//             title="Resim Yükle"
//             centered
//             visible={open}
//             onOk={() => generateDownload(previewCanvasRef.current, completedCrop)}
//             onCancel={() => onClose()}
//             width={"100%"}
//         >
//             <div className="input-box">
//                 <input type="file" accept="image/*" onChange={onSelectFile} />
//             </div>
//             <div className="image-box">
//                 {/*<button onClick={() => {*/}
//                 {/*    console.log(upImg, 'up ımage');*/}
//                 {/*}}>TEST</button>*/}
//                 <div className="crop-box">
//                     <ReactCrop
//                         src={upImg}
//                         onImageLoaded={onLoad}
//                         crop={crop}
//                         onChange={(c) => setCrop(c)}
//                         onComplete={(c) => setCompletedCrop(c)}
//                     />
//                 </div>
//                 {upImg && (
//                     <div style={{marginRight: '10px'}}>
//                         <RightSquareOutlined style={{fontSize: '40px'}} />
//                     </div>
//                 )}
//
//
//                 {upImg && (
//                     <div className="crop-result-box">
//                         <canvas
//                             ref={previewCanvasRef}
//                             // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
//                             style={{
//                                 width: Math.round(completedCrop?.width /1.2 ?? 0),
//                                 height: Math.round(completedCrop?.height /1.2 ?? 0)
//                             }}
//                         />
//                     </div>
//                 )}
//
//             </div>
//        </Modal>
//     );
// }
